module.exports = __webpack_public_path__ + "assets/img/icon-power-install-white.svg";